<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>

    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" style="display:block;">

      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">{{title}}</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>

      <div class="rew19_popup_cont">
        <dl class="rew19_select_table">
          <dt>
            <span class="rew19_table_tit">총 {{$fmt.PDCnt(viewData.pd_list.length)}}개 상품</span>
            <div class="rew19_rpBt">
              <a @click="onClickDeleteSelectedProduct" class="rew19_btn_intable">삭제</a>
              <a v-show="prodAppendYn" @click="openProductAddDialog" class="rew19_btn_intable active">+상품추가</a>
            </div>
          </dt>

          <!-- 상품 Row1 -->
          <dd class="rew19_dividing_line"
            v-for="(product, pIdx) in viewData.pd_list"
            :key="product.pd_id+pIdx">
            <div class="rew19_product_tit">
              <div class="rew19_wrapCheck_t1">
                <input
                  v-model="product.checked"
                  type="checkbox"
                  class="rew19_fakeCheck_t1"
                  :id="'checkProd+'+product.pd_id">
                <label :for="'checkProd+'+product.pd_id">{{product.pd_name_kr}}</label>
              </div>
              <button @click="onClickDeleteProduct(product)"><span>삭제</span></button>
            </div>

            <div class="rew19_product_cont">
              <div class="rew19_relative rew19_relative_add rew19_change_position">
                <div class="rew19_goodsWrap">
                  <div class="rew19_goodsImg dev-productDetail">
                    <i class="rew19_goodsFlag "></i>
                    <span class="rew19_rateImg">
                      <img
                        :src="product.pd_img_url1"
                        :alt="product.pd_id"
                        onError="imageError(this)" data-error-cnt="0"
                      />
                    </span>
                  </div>
                </div>
                <div class="rew19_product_select">
                  <ul class="rew19_product_items">
                    <li>
                      <em class="rew19_gTit">정기구매가</em>
                      <span class="rew19_gDetail">
                        <strong>{{$fmt.WON(product.pd_amt)}}</strong>원
                      </span>
                    </li>
                    <template v-if="getMemberType() == 'DIST'">
                      <li>
                        <em class="rew19_gTit">SV</em>
                        <span class="rew19_gDetail">{{$fmt.PV(product.pv)}}</span>
                      </li>
                      <li>
                        <em class="rew19_gTit">CSV</em>
                        <span class="rew19_gDetail">{{$fmt.PV(product.cv)}}</span>
                      </li>
<!--                      <li>-->
<!--                        <em class="rew19_gTit">SB</em>-->
<!--                        <span class="rew19_gDetail">{{$fmt.PV(product.sb)}}</span>-->
<!--                      </li>-->
                    </template>
                  </ul>
                  <div class="rew19_numbering_wrap">
                    <em class="rew19_gTit">수량</em>
                    <div class="rew19_numbering">
                      <a
                        @click="onClickUpdateProductCount(product, -1)"
                        class="rew19_numbering_down dev-prod-qty-down"
                        title="감소"></a>
                      <input
                        v-model="product.pd_count"
                        @keypress="numberKeyPress($event)"
                        @keyup="onClickUpdateProductCount(product)"
                        :readonly="product.agm_info || product.isLimitedQty == 'Y'"
                        @click="onClickChangeCount(product)"
                        type="tel"
                        class="onlynum dev-prod-qty"
                        title="수량"
                      />
                      <a
                        @click="onClickUpdateProductCount(product, +1)"
                        class="rew19_numbering_up dev-prod-qty-up"
                        title="증가"></a>
                    </div>

                    <div class="rew19_summary_wrap">
                      <em class="rew19_gTit">합계</em>
                      <span class="rew19_gDetail"><strong>{{$fmt.WON(product.total_amt)}}</strong>원</span>
                    </div>
                  </div>
                </div><!--//rew19_product_select-->
              </div><!--//rew19_relative-->
            </div><!--//rew19_product_cont-->

            <!-- Skincode List-->
            <ul v-if="product.agm_info"
              class="rew19_codeList">
              <li class="rew19_codeRow">
                <span class="rew19_codeCol c1">순번</span>
                <span class="rew19_codeCol c2">이름</span>
                <span class="rew19_codeCol c3">코드</span>
                <span class="rew19_codeCol c4">코드별명</span>
                <span class="rew19_codeCol c5">코드조회</span>
                <span class="rew19_codeCol c6">삭제</span>
              </li>

              <li class="rew19_codeRow"
                v-for="(item, idx) in product.agm_info"
                v-bind:key="idx"
              >
                <span class="rew19_codeCol c1">{{idx + 1}}</span>
                <span class="rew19_codeCol c2">
                  <em>이름</em>
                  <input
                    v-model.trim="item.agm_name"
                    type="text"
                    title="이름"
                    maxlength="12"
                    class="rew19_inputTxt_t1"
                  />
                </span>
                <span class="rew19_codeCol c3">
                  <em>코드</em>
                  <input
                    v-model.trim="item.agm_code"
                    @input="toUpper(pIdx, idx)"
                    type="text"
                    title="코드"
                    style="text-transform: uppercase; ime-mode:inactive"
                    maxlength="6"
                    class="rew19_inputTxt_t1"
                  />
                </span>
                <span class="rew19_codeCol c4">
                  <em>코드별명</em>
                  <input
                    v-model.trim="item.agm_detail"
                    type="text"
                    title="코드별명"
                    maxlength="26"
                    class="rew19_inputTxt_t1"
                  />
                </span>
                <span class="rew19_codeCol c5">
                  <button
                    @click="openSkinCareCodeListDialog(item)"
                    type="button" class="rew19_basketBtn_search">조회</button>
                </span>
                <span class="rew19_codeCol c6">
                  <button
                    @click="onClickDeleteSkinCode(product, item)"
                    type="button" class="rew19_basketBtn_del">삭제</button>
                </span>
              </li>

            </ul>
            <!-- //Skincode List-->
          </dd>
          <!-- //상품 Row1 -->
          <div class="rew19_payment_bottom">

          <ul class="rew19_payList">
              <template v-if="getMemberType() == 'DIST'">
                <li>
                    <em class="rew19_payTitle">합계 SV</em>
                    <span class="rew19_payDetail">
                        {{$fmt.PV(viewData.total_pv)}}
                    </span>
                </li>
                <li>
                    <em class="rew19_payTitle">합계 CSV</em>
                    <span class="rew19_payDetail">
                        {{$fmt.PV(viewData.total_cv)}}
                    </span>
                </li>
<!--                <li v-if="isShowTotalSb">-->
<!--                    <em class="rew19_payTitle">합계 SB</em>-->
<!--                    <span class="rew19_payDetail">-->
<!--                        {{$fmt.PV(viewData.total_sb)}}-->
<!--                    </span>-->
<!--                </li>-->
              </template>
              <li v-bind:class="{lastLine : getMemberType() == 'DIST'}">
                  <em class="rew19_payTitle">주문금액</em>
                  <span class="rew19_payDetail rew19_point">
                          <strong>{{$fmt.WON(viewData.total_amt)}} 원</strong>
                  </span>
              </li>
          </ul>

    </div>


        </dl>

        <div v-show="prodAppendYn" class="rew19_responsive_btns gepTaye1">
          <a @click="openProductAddDialog" class="rew19-btn-pline">+ 상품 변경/추가</a>
        </div>

      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">변경완료</button>
      </div>

    </div>

    <!--스킨케어 코드 목록 조회 -->
    <skin-care-code-list-dialog
      :show="skinCareCodeListDialogShow"
      @close="setSkinCareCodeFromList"
      ref="skinCareCodeListDialog"
    ></skin-care-code-list-dialog>

    <!-- 상품추가 -->
    <product-add-dialog
      :show="productAddDialogShow"
      :title="'나의 정기구매 주문 상품 추가'"
      ref="productAddDialog"
      @close="productAddDialogClose"
      @onProductAdd="onProductAdd"
    ></product-add-dialog>

    <!-- 상품추가 -->
    <cart-added-popup
      :show="showCartAdded"
      :message="'제품이 추가 되었습니다.'"
    ></cart-added-popup>

  </div>
</template>
<script>
import ProductAddDialog from '@/components/popup/ProductAddDialog';
import SkinCareCodeListDialog from '@/components/popup/SkinCareCodeListDialog';
import CartAddedPopup from '@/components/popup/CartAdded';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import AroBase from '@/components/base/AroBase';

const MAX_PD_COUNT = 999;
const ERR_TITLE = "안내";
const ERR_MSG_MIN_PD_COUNT = "최소 구매 수량보다 작습니다.";
const ERR_MSG_MAX_PD_COUNT = "최대 구매 수량을 초과 하였습니다.";

const DEFAULT_VIEWDATA = {
  pd_list : [],
  aro_no : "",
  total_pv : "",
  total_cv : "",
  // total_sb : "",
  total_amt : "",
};

const AGM_DEF_OBJ = {
  agm_code: "",
  agm_name: "",
  agm_detail: ""
};

const PD_DEF_OBJ = {
  checked : false,
  pd_id: "",
  pd_amt: 0,
  pd_count: "1",
  cv: 0.0,
  pd_img_url1: "",
  pd_img_url2: "",
  pd_name_kr: "",
  pv: 0.00,
  // sb: 0,
  total_amt: 0,
  saving_percentage: "5",
  //order_dt: null,
};

export default {
  name: 'ProductChangeDialog',
  extends: AroBase,
  components: {
    ProductAddDialog,
    SkinCareCodeListDialog,
    CartAddedPopup
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title:{
      type: String,
      require : true,
    },
    memberId:{
      type: String,
      require : true,
    },
    prodAppendYn:{
      type: Boolean,
      default : true,
    }
  },
  data() {
    return {
      currentZIndex : 2000,

      viewData : {...DEFAULT_VIEWDATA},

      defaultdata : {...DEFAULT_VIEWDATA},

      //스킨케어코드 조회 Dialog
      skinCareCodeListDialogShow : false,
      skinCareCodeListDialog : {},

      //상품 추가 Dialog
      productAddDialogShow : false,
      productAddDialog : {},

      //상품 추가 완료 Dialog
      showCartAdded : false,
      // isShowTotalSb : false
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      let headerHeight = $(".rew19_popContainer.big .rew19_popup_wrap").height();
      let btnHeight = $(".rew19_popContainer.big .rew19_popup_btn").height();
      //console.debug(`differ Height:${headerHeight+ btnHeight}`);
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height()
        - headerHeight - btnHeight);
    })
  },
  mounted() {
    let _this = this;

  },
  methods :{
    onClose(response) {
      let _this = this;

      let resData = null;
      if(_this.viewData.aro_no != ''){
        resData = _this.viewData;
      }else{
        resData = _this.viewData.pd_list;
      }


      _this.$emit('close', response, response ? resData: null);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      let resData = null;


      resData = _this.viewData.pd_list;

      let check = true;
      resData.filter(prod=>{
        if(prod.agm_info){
          prod.agm_info.filter(agm=>{
            if(agm.agm_name == '' || agm.agm_code == ''){
              _this.$dialogs.alert('에이지락 미 커스텀 프로덕트 세트 주문 시에는 스킨 케어 정보 입력이 반드시 필요합니다. 코드를 입력해주세요.').then(res=>{});
              check = false;
              return;
            }
          });
        }
      });

      if(check){
        this.onClose(true);
      }
    },

    /**
     * API Request
     */

    /**
     * Local
     */
    initData : function(paramData){
      let _this = this;

      _this.viewData = {
        ...DEFAULT_VIEWDATA,
        ...paramData,
      };

      _this.defaultdata = {...DEFAULT_VIEWDATA, ...paramData};

      if(!_this.viewData.pd_list){
        _this.viewData.pd_list = [];
      }

      _this.viewData.pd_list = _this.viewData.pd_list.map(prod=>{
        return {
          ...prod,
          checked : false
        }
      });

      // if(_this.getMemberType() == "DIST" && _this.getMemberTitle() >= 40){
      //   _this.isShowTotalSb = true;
      // }

      _this.setTotalAmt();
    },

    //선택상품 삭제
    onClickDeleteSelectedProduct(){
      let _this = this;

      let selectedList = _this.viewData.pd_list.filter(prod=>{
        return prod.checked;
      });

      if(selectedList.length <= 0){

        const msg = "삭제할 상품을 선택해 주십시오.";
        _this.$dialogs.alert(msg).then(res=>{});
        return;
      }

      {
        const options = {cancelLabel: '취소', okLabel:'삭제'};
        const msg = "선택하신 상품을 삭제 하시겠습니까?"

        _this.$dialogs.confirm(msg, options).then(res=>{
          if(res.ok){
            _this.viewData.pd_list = _this.viewData.pd_list.filter(prod=>{
              return !prod.checked;
            });
            _this.setTotalAmt();
          }
        });
      }
    },

    //해당상품 삭제
    onClickDeleteProduct(product){
      let _this = this;
      _this.viewData.pd_list = _this.viewData.pd_list.filter(prod=>{
        return prod != product;
      });
      _this.setTotalAmt();
    },

    //상품 수량 변경
    onClickUpdateProductCount(product, add){
      let _this =  this;
      let oldCnt = 0;
      let newCnt = oldCnt;
      let usingText = undefined === add || null === add;

      if(!product.pd_count || product.pd_count == NaN){
        oldCnt = newCnt = 0;
      }else{
        oldCnt = (""+product.pd_count).replace(/[^0-9]/g, "");
        oldCnt = parseInt(""+oldCnt, 10);
      }

      if(usingText){
        newCnt = oldCnt;
      }else{
        newCnt = oldCnt + add;
      }

      if(newCnt < 1){
        newCnt = 1;
      }

      if(MAX_PD_COUNT < newCnt){
        _this.$dialogs.alert(ERR_MSG_MAX_PD_COUNT, {title: ERR_TITLE})
        .then(res => {});
        newCnt = MAX_PD_COUNT;
      }

      let defaultProduct = _this.defaultdata.pd_list.filter(item=>{
        return item.pd_id == product.pd_id;
      });


      //수량 변경 불가 사항 추가
      if(product.isLimitedQty && product.isLimitedQty == 'Y' && newCnt > defaultProduct[0].pd_count){
        _this.$dialogs.alert('해당 제품은 원활한 재고 운영을 위하여 일시적으로 정기구매 수량 변경이 제한됩니다.<br/>※ 수량 감소 및 제품 삭제만 가능 / 수량 증가 및 신규추가  불가<br/>※ 자세한 사항은 뉴스킨몰 공지사항 참고').then(res=>{});
      }else{
        _this.viewData.pd_list = _this.viewData.pd_list.map(item=>{
          if(product.pd_id != item.pd_id) {
            return item;
          }

            item.pd_count = newCnt,
            item.total_pv = newCnt * item.pv,
            item.total_cv = newCnt * item.cv,
            // item.total_sb = newCnt * item.sb,

            item.total_amt = newCnt * item.pd_amt

            _this.setTotalAmt();

          if(product.pd_id == Const.ARO_SKINCARE_PRODUCT_ID){
            _this.adjustAgmCodeList(item);
          }

          return item;
        });
      }
    },

    //Ageloc me skincare code list 조정
    adjustAgmCodeList(productItem){
      if(productItem.pd_id != Const.ARO_SKINCARE_PRODUCT_ID){
        return;
      };

      const cRefAgmList = productItem.agm_info ? productItem.agm_info : productItem.agm_info = [];

      if(cRefAgmList.length <= productItem.pd_count){
        for(var i=0; i < productItem.pd_count - cRefAgmList.length; i++){
          productItem.agm_info.push(JSON.parse(JSON.stringify(AGM_DEF_OBJ)));
        }
      }else if(cRefAgmList.length > productItem.pd_count){
        productItem.agm_info.splice(cRefAgmList.length-1, cRefAgmList.length - productItem.pd_count);
      }
    },

    //스킨케어 목록 삭제
    onClickDeleteSkinCode(prod, agmItem){
      //스킨케어 목록에서 제거
      prod.agm_info = prod.agm_info.filter(item=>{
        return item != agmItem;
      });

      //수량 수정
      let oldCount = parseInt(prod.pd_count, 10);
      prod.pd_count = oldCount - 1;
    },

    //open dialog 스킨케어 코드 조회
    openSkinCareCodeListDialog(agmItem){
       let _this = this;

      //pass data to dialog
      _this.skinCareCodeListDialog = {
        ..._this.skinCareCodeListDialog,
        memberId : _this.memberId,
        targetAgm : agmItem,
      };

      _this.$refs.skinCareCodeListDialog.initData(_this.skinCareCodeListDialog);

      _this.skinCareCodeListDialogShow = true;
    },

    //스킨케어 선택시
    setSkinCareCodeFromList(isOk, data){
      let _this =  this;

      _this.skinCareCodeListDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      _this.skinCareCodeListDialog.targetAgm.agm_code = data.assessmentCode;
      _this.skinCareCodeListDialog.targetAgm.agm_name = data.personName;
      _this.skinCareCodeListDialog.targetAgm.agm_detail = data.assessmentLabel;
    },

    //Open dialog 상품 추가
    openProductAddDialog(){
      let _this = this;

      //pass data to dialog
      _this.productAddDialog = {
        ..._this.productAddDialog,
        aro_payment_count : _this.viewData.aro_payment_count
      };

      _this.$refs.productAddDialog.initData(_this.productAddDialog);
      _this.productAddDialogShow = true;
    },

    //Close dialog 상품 추가
    productAddDialogClose(){
      let _this = this;
      _this.productAddDialogShow = false;
    },

    //주문상품 변경
    onProductAdd(addProdInfo){
      let _this = this;

      let foundProdList = _this.viewData.pd_list.filter(item=>{
        return item.pd_id == addProdInfo.pd_id;
      });

      let targetPdInfo = null;
      if(foundProdList && foundProdList.length == 1){
        //기존에 동일 상품이 있을 경우
        targetPdInfo = foundProdList[0];

        let newCount = parseInt(targetPdInfo.pd_count, 10)+1;
        targetPdInfo.pd_count = ""+(newCount);
        targetPdInfo.total_amt = (newCount * targetPdInfo.pd_amt);
      }else{
        //신규 상품

        let newPdInfo = JSON.parse(JSON.stringify(PD_DEF_OBJ));
        newPdInfo = {
          ...newPdInfo,
          pd_id : addProdInfo.pd_id,
          pd_count : "1",
          pd_amt : _this.viewData.aro_payment_count >= 3 ? addProdInfo.pd_amt2 : addProdInfo.pd_amt1,
          cv : addProdInfo.cv1,
          pd_img_url1 : addProdInfo.pd_img_url1,
          pd_img_url2 : addProdInfo.pd_img_url2,
          pd_name_kr : addProdInfo.pd_name_kr,
          pv : addProdInfo.pv1,
          // sb : addProdInfo.sb1,
          total_amt : _this.viewData.aro_payment_count >= 3 ? addProdInfo.pd_amt2 : addProdInfo.pd_amt1,
        };
        _this.viewData.pd_list.push(newPdInfo);
        targetPdInfo = newPdInfo;
      }

      if(addProdInfo.pd_id == Const.ARO_SKINCARE_PRODUCT_ID){
        _this.adjustAgmCodeList(targetPdInfo);
      }

      _this.setTotalAmt();

      //제품추가 완료 Popup
      _this.showCartAdded = true;
      setTimeout(()=>{
        _this.showCartAdded = false;
      }, 1000);
    },

    onClickChangeCount(product){
      let _this = this;

      if(product.isLimitedQty == 'Y'){
        _this.$dialogs.alert('해당 제품은 원활한 재고 운영을 위하여 일시적으로 정기구매 수량 변경이 제한됩니다.<br/>※ 수량 감소 및 제품 삭제만 가능 / 수량 증가 및 신규추가  불가<br/>※ 자세한 사항은 뉴스킨몰 공지사항 참고').then(res=>{});
      }
    },

    /**
     * Util
     */
    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    keyUpToNumber(evt, callback){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },

    toUpper(pIdx, index){
      let _this = this;

      _this.viewData.pd_list[pIdx].agm_info[index].agm_code = _this.viewData.pd_list[pIdx].agm_info[index].agm_code.toUpperCase();

    },

    setTotalAmt(){
      let _this = this;

      let total_pv = 0;
      let total_cv = 0;
      // let total_sb = 0;
      let total_amt = 0;

      _this.viewData.pd_list = _this.viewData.pd_list.filter(prod=>{
        total_pv = total_pv + (prod.pv * prod.pd_count);
        total_cv = total_cv + (prod.cv * prod.pd_count);
        // total_sb = total_sb + (prod.sb * prod.pd_count);
        total_amt = total_amt + prod.total_amt;
        return prod;
      });

      _this.viewData.total_pv = total_pv;
      _this.viewData.total_cv = total_cv;
      // _this.viewData.total_sb = total_sb;
      _this.viewData.total_amt = total_amt;
    }
  }
}
</script>
<style>
a.rew19_btn_intable, a.rew19-btn-pline{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ProductChangeDialog.vue